import { comments } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">读者热评</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">听听漫友们怎么说，每一份热爱都值得被看见</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-xl p-5 flex flex-col gap-3 border border-background-200/50 hover:border-primary-200/60 transition-colors"
            >
              <div className="flex items-center gap-3">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 truncate">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
                <div className="flex items-center gap-1 text-foreground-500 flex-shrink-0">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-thumb-up-line text-xs"></i>
                  </span>
                  <span className="text-xs">{comment.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed line-clamp-3">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}